<template>
  <div class="companyInfo">
    <div class="whole_company_from">
      <el-form ref="form" :model="form" @submit.native.prevent>
        <QS-search maxLine="2" :forceNewLine="false">
          <!-- 内容区域-->
          <el-form-item prop="name" label="角色名称">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入角色名称"
              clearable
            />
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <el-form-item>
            <el-button
              :loading="BLMloading"
              type="primary"
              size="small"
              @click="search"
            >
              查询
            </el-button>
            <el-button size="small" @click="reset"> 重置 </el-button>
          </el-form-item>
          <!-- </template> -->
        </QS-search>
      </el-form>
    </div>
    <el-button
      @click="add"
      type="primary"
      size="small"
      v-if="judgePermission('tenant_new_role_list_create')"
    >
      新建角色
    </el-button>
    <div class="mt16">
      <QS-common-table
        :loading="BLMloading"
        :pagination="paginationData"
        :data="tableData"
        :columns="headData"
        @change="paginationChange"
      ></QS-common-table>

      <AddAndEditRoleDrawer
        @refresh="handleRefresh"
        :visible.sync="visible"
        :id="editRowId"
        :mode="mode"
        :isSysRole="isSysRole"
      />
      <StuffDrawer ref="stuffDrawer"/>
    </div>
  </div>
</template>

<script>
import AddAndEditRoleDrawer from '../components/addAndEditRole.vue'
// eslint-disable-next-line import/no-cycle
import { tRoleList, tRoleDel } from '@/api/domain/organize.js'
import StuffDrawer from '../components/stuffs.vue'
import { debounce } from '@/utils'
import { MODE_ENUM, config } from '../config/role'

export default {
  name: 'employeeRole',
  components: {
    AddAndEditRoleDrawer,
    StuffDrawer,
  },
  data() {
    const { headData, operateColumn } = config.call(this)
    return {
      visible: false,
      mode: 1,
      isSysRole: false,
      editRowId: null,
      BLMloading: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      form: { name: '' },
      tableData: [],
      headData,
      operateColumn,
    }
  },
  created() {
    this.headData.push(this.operateColumn)
  },
  methods: {
    handleRefresh() {
      this.loadData()
    },
    search: debounce(async function () {
      this.paginationData.pageNum = 1
      this.loadData()
    }, 500),
    async loadData() {
      this.BLMloading = true
      const { code, data } = await tRoleList({
        ...this.form,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      })
      if (code === 1) {
        this.paginationData.total = data.totalNum
        this.tableData = data.items
        this.BLMloading = false
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    async deleteRole(row) {
      const msg = row.userCount > 0 ? `当前角色【${row.name}】有绑定中的账号，无法删除，请解绑` : `请确认删除当前角色【${row.name}】`
      const title = row.userCount > 0 ? '请确认删除角色' : '删除角色'
      this.$confirm(msg, title, {
        confirmButtonText: row.userCount > 0 ? '查看绑定账号' : '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        if (row.userCount > 0) {
          // 弹出抽屉
          this.$refs.stuffDrawer.open(row.id)
          return
        }
        const res = await tRoleDel({
          id: row.id,
        })
        if (res.code === 1) {
          this.$message({
            type: 'success',
            message: '已删除',
          })
          this.loadData()
        }
      })
    },
    reset() {
      this.$refs.form.resetFields()
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.loadData()
    },
    /* 分页切换 */
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.loadData()
    },
    // eslint-disable-next-line vue/no-unused-properties
    edit(row) {
      this.editRowId = row.id
      this.isSysRole = false
      this.mode = MODE_ENUM.EDIT
      this.visible = true
    },
    // eslint-disable-next-line vue/no-unused-properties
    info(row) {
      this.editRowId = row.id
      this.isSysRole = row.type === 1
      this.mode = MODE_ENUM.STATIC
      this.visible = true
    },
    // 复制
    // eslint-disable-next-line vue/no-unused-properties
    copy(row) {
      this.editRowId = row.id
      this.isSysRole = false
      this.mode = MODE_ENUM.COPY
      this.visible = true
    },
    add() {
      this.editRowId = null
      this.mode = MODE_ENUM.ADD
      this.visible = true
      // 新增的不是系统角色，抽屉的底部按钮要显示
      this.isSysRole = false
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__wrapper.editRoleDialog .el-dialog .el-dialog__body {
  max-height: calc(80vh - 70px);
}
.whole_company_from ::v-deep .el-form-item__content {
  display: flex;
  .el-button:nth-of-type(2) {
    margin-left: 8px;
  }
}
</style>
